import Button from "backpack-ui/dist/components/button";
import * as cn from "classnames";
import * as React from "react";
import * as styles from "./styles.css";
var BookingButton = function (_a) {
    var children = _a.children, href = _a.href, onClick = _a.onClick, className = _a.className;
    return (React.createElement("div", { className: cn(styles.bookingButton, className) },
        React.createElement(Button, { href: href, onClick: onClick, full: true, rounded: true, target: "_blank", rel: "noopener noreferrer" }, children)));
};
export default BookingButton;



//////////////////
// WEBPACK FOOTER
// ./app/modules/pois/patterns/booking/bookingButton.tsx
// module id = KReW
// module chunks = 2